var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBollywood = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Landmark-Taj-Mahal--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Landmark Taj Mahal Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1 12.5h1.5s0.5 0 0.5 0.5v10.5s0 0.5 -0.5 0.5H1s-0.5 0 -0.5 -0.5V13s0 -0.5 0.5 -0.5",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12.5H23s0.5 0 0.5 0.5v10.5s0 0.5 -0.5 0.5h-1.5s-0.5 0 -0.5 -0.5V13s0 -0.5 0.5 -0.5",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.31 4.22A2.47 2.47 0 0 0 15 2.51a0.5 0.5 0 0 0 -0.37 -0.51 0.52 0.52 0 0 0 -0.57 0.24 0.8 0.8 0 0 1 -0.15 0.21 1 1 0 0 1 -1.41 0 1 1 0 0 1 0 -1.42 0.7 0.7 0 0 1 0.19 -0.15 0.51 0.51 0 0 0 0.21 -0.58 0.48 0.48 0 0 0 -0.5 -0.35 2.53 2.53 0 0 0 -1.68 0.77 2.5 2.5 0 1 0 3.62 3.45Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.87 7A5.18 5.18 0 0 0 0 9.25a1.75 1.75 0 0 0 3.5 0A5.18 5.18 0 0 0 2.63 7 1 1 0 0 0 0.87 7Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 11A1.76 1.76 0 0 0 24 9.25 5.18 5.18 0 0 0 23.13 7a1 1 0 0 0 -1.76 0 5.18 5.18 0 0 0 -0.87 2.22A1.76 1.76 0 0 0 22.25 11Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 15H5a0.5 0.5 0 0 0 -0.5 0.5v8a0.5 0.5 0 0 0 0.5 0.5h1.5a0.5 0.5 0 0 0 0.5 -0.5V20a1 1 0 0 1 2 0v3.5a0.5 0.5 0 0 0 0.5 0.5h1a0.5 0.5 0 0 0 0.5 -0.5V20a1 1 0 0 1 2 0v3.5a0.5 0.5 0 0 0 0.5 0.5h1a0.5 0.5 0 0 0 0.5 -0.5V20a1 1 0 0 1 2 0v3.5a0.5 0.5 0 0 0 0.5 0.5H19a0.5 0.5 0 0 0 0.5 -0.5v-8a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79 13.5h10.42a0.49 0.49 0 0 0 0.45 -0.3 4.19 4.19 0 0 0 0.34 -1.7c0 -2.7 -5.17 -5.62 -5.76 -5.94a0.51 0.51 0 0 0 -0.48 0C11.17 5.88 6 8.8 6 11.5a4.19 4.19 0 0 0 0.34 1.7 0.49 0.49 0 0 0 0.45 0.3Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBollywood);
export default ForwardRef;